/** HTML标签 */
import React from 'react';
import ReactEcharts from '../Echarts/ReactEcharts';

class HTMLEcharts extends React.Component{
  timeIdx;
  // 重新绘制
  UNSAFE_componentWillReceiveProps = () => {
    clearTimeout(this.timeIdx);
    this.timeIdx = setTimeout(() => {
      if (this.refs.HTMLEcharts) {
        this.refs.HTMLEcharts.updateEcharts();
      }
    }, 60);
  };
  // 绘图
  getOption() {
    const {echartsData, rowData} = this.props;
    let name = [];
    let value = [];
    echartsData.forEach(item => {
      item.name === 'xmlhttprequest'
        ? name.push('XHR')
        : name.push(item.name);
      value.push(item.value);
    });
    // 尽量让图表水平对齐
    let bigLen = 0;
    let temLen = 0;
    rowData.domainList && rowData.domainList.forEach(item => {
      temLen = (item.name.includes('://') ? item.name.split('://')[1].length : item.name.length);
      if(temLen > bigLen) {
        bigLen = temLen
      }
    });
    let btm = 2.06667 * bigLen;
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      grid: {
        left: '15',
        right: '40',
        top: '40',
        bottom: btm > 60 ? 60 : btm,
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          axisLabel: {
            interval: 0
          },
          data: name
        }
      ],
      yAxis: [
        {
          type: 'value',
          scale: true,
          name: 'HTML标签',
          nameTextStyle: {
            color: '#333'
          },
          min: 0,
          boundaryGap: [0.2, 0.2]
        }
      ],
      series: [
        {
          name: 'HTML标签',
          type: 'bar',
          itemStyle : {
            color:'#3AA1FF',
            lineStyle:{
              color:'#3AA1FF'
            }
          },
          data: value
        }
      ]
    };
    return option;
  };
  render() {
    const {echartsData} = this.props;
    return (
      <ReactEcharts ref='HTMLEcharts' key='HTMLEcharts' option={this.getOption()} isHide={echartsData.length === 0} w='50%' h={300}></ReactEcharts>
    );
  }
};
export default HTMLEcharts;
